
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { TLoadable, isLoaded, createLoaded } from "../../../../sg-core";
import { selectHavainnotState } from "../selectors";
import ICategory from "../../interfaces/ICategory";
import IFormType from "../../interfaces/IFormType";
import { useFormTypeList } from "./formSelectors";


// SELECTORS
const selectCategoryState = createSelector(
    selectHavainnotState,
    (workPermit) => workPermit.categories
);

export const selectCategoriesByIdState = createSelector(
    selectCategoryState,
    (state) => state.categories,
);

const selectCategoriesIdList = createSelector(
    selectCategoryState,
    (state) => state.categoryList,
)

export const selectCategoryList = createSelector(
    selectCategoriesIdList,
    selectCategoriesByIdState,
    (categoryList, categories): TLoadable<ICategory[]> => {
        if (isLoaded(categoryList)) {
            return createLoaded(categoryList.data.map((id) => categories[id]));
        }
        return categoryList as TLoadable<ICategory[]>
    },
);



// HOOKS
export const useCategoryList = (): TLoadable<ICategory[]> => useSelector(selectCategoryList) as any;
export const useCategoryById = (categoryId: number | undefined): ICategory | undefined => {
    const categories = useSelector(selectCategoriesByIdState)
    return categoryId ? categories[categoryId] : undefined
};

export const useFormTypeListByCategoryId = (categoryId: number): TLoadable<IFormType[]> => {
    const typeList = useFormTypeList();

    if (categoryId && isLoaded(typeList)) {
        return createLoaded(typeList.data.filter(({ id }) => id !== categoryId));

    } else if (isLoaded(typeList)) {
        return createLoaded([])
    }

    return typeList
};
